import dosage from './dosage';

export default (medicationRequest = {}) => {
  return Object.assign({
    'id': null,
    'resourceType': 'MedicationRequest',
    'requester': {},
    'subject': {},
    'medicationReference': {},
    'supportingInformation': [],
    'dosageInstruction': [dosage()],
    'dispenseRequest': {}
  }, medicationRequest);
};
